/**
 * Generates a PKCE (Proof Key for Code Exchange) code pair for OAuth 2.0 authorisation flows.
 * The verifier is a high-entropy random string; the challenge is its SHA-256 hash, both base64url-encoded.
 * @returns Object containing the `codeVerifier` (kept by the client) and the `codeChallenge` (sent to the auth server).
 * @category Utils
 * @see https://datatracker.ietf.org/doc/html/rfc7636
 */
export const getPkceCodePair = async () => {
  const codeVerifier = base64URLEncode(generateRandomBytes(32))
  const codeChallenge = base64URLEncode(await sha256(codeVerifier))

  return {
    codeVerifier,
    codeChallenge
  }
}
